export default __webpack_public_path__ + "static/media/intelligent-quality.ca78d188.svg";